module.exports = __webpack_public_path__ + "static/media/glanceNav.66c15f90.svg";